import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCalendar({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      fill="#666"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M5.8 0c.24 0 .44.2.44.45v1.4h3.52V.46c0-.25.2-.45.45-.45h1.16c.24 0 .44.2.44.45v1.4h1.3c.82 0 1.49.68 1.49 1.5v10.21c0 .83-.67 1.5-1.5 1.5H2.9a1.5 1.5 0 01-1.5-1.5V3.35c0-.82.67-1.5 1.5-1.5h1.29V.46c0-.25.2-.45.44-.45H5.8zM13 4.84H3v8.55c0 .03.01.06.04.07h9.89c.03 0 .06-.01.07-.04V4.84zM8.59 9.3c.25 0 .45.2.45.44v1.16c0 .25-.2.45-.45.45H7.42a.45.45 0 01-.45-.45V9.73c0-.24.2-.44.45-.44h1.16zm-2.79 0c.25 0 .45.2.45.44v1.16c0 .25-.2.45-.45.45H4.63a.45.45 0 01-.44-.45V9.73c0-.24.2-.44.44-.44H5.8zm5.58 0c.24 0 .44.2.44.44v1.16c0 .25-.2.45-.44.45H10.2a.45.45 0 01-.45-.45V9.73c0-.24.2-.44.45-.44h1.16zM5.79 6.5c.25 0 .45.2.45.45V8.1c0 .25-.2.45-.45.45H4.63a.45.45 0 01-.44-.45V6.95c0-.25.2-.45.44-.45H5.8zm2.79 0c.25 0 .45.2.45.45V8.1c0 .25-.2.45-.45.45H7.42a.45.45 0 01-.45-.45V6.95c0-.25.2-.45.45-.45h1.16zm2.79 0c.24 0 .44.2.44.45V8.1c0 .25-.2.45-.44.45H10.2a.45.45 0 01-.45-.45V6.95c0-.25.2-.45.45-.45h1.16z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCalendar.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCalendar.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCalendar svgRef={ref} {...props} />);
export default ForwardRef;
